import { KEYS } from "@excalidraw/common";

import {
  SelectionIcon,
  RectangleIcon,
  DiamondIcon,
  EllipseIcon,
  TriangleIcon,
  PentagonIcon,
  ArrowIcon,
  LineIcon,
  FreedrawIcon,
  TextIcon,
  ImageIcon,
  EraserIcon,
  laserPointerToolIcon,
  trailLaserPointerIcon,
} from "./icons";

import type { AppClassProperties } from "../types";

export const SHAPES = [
  {
    icon: SelectionIcon,
    value: "selection",
    key: KEYS.V,
    numericKey: KEYS["1"],
    fillable: true,
  },
  {
    icon: RectangleIcon,
    value: "rectangle",
    key: KEYS.R,
    numericKey: KEYS["2"],
    fillable: true,
  },
  {
    icon: DiamondIcon,
    value: "diamond",
    key: KEYS.D,
    numericKey: KEYS["3"],
    fillable: true,
  },
  {
    icon: EllipseIcon,
    value: "ellipse",
    key: KEYS.O,
    numericKey: KEYS["4"],
    fillable: true,
  },
  {
    icon: TriangleIcon,
    value: "triangle",
    key: null, // 避免与文本工具冲突
    numericKey: KEYS["5"],
    fillable: true,
  },
  {
    icon: PentagonIcon,
    value: "pentagon",
    key: null, // 暂时不设置快捷键
    numericKey: KEYS["6"],
    fillable: true,
  },
  {
    icon: ArrowIcon,
    value: "arrow",
    key: KEYS.A,
    numericKey: KEYS["7"],
    fillable: true,
  },
  {
    icon: LineIcon,
    value: "line",
    key: KEYS.L,
    numericKey: KEYS["8"],
    fillable: true,
  },
  {
    icon: FreedrawIcon,
    value: "freedraw",
    key: [KEYS.P, KEYS.X],
    numericKey: KEYS["9"],
    fillable: false,
  },
  {
    icon: TextIcon,
    value: "text",
    key: KEYS.T,
    numericKey: null,
    fillable: false,
  },
  {
    icon: ImageIcon,
    value: "image",
    key: null,
    numericKey: null,
    fillable: false,
  },
  {
    icon: EraserIcon,
    value: "eraser",
    key: KEYS.E,
    numericKey: null,
    fillable: false,
  },
  {
    icon: laserPointerToolIcon,
    value: "laser",
    key: null,
    numericKey: null,
    fillable: false,
  },
  {
    icon: trailLaserPointerIcon,
    value: "laserTrail",
    key: null,
    numericKey: null,
    fillable: false,
  },
] as const;

export const getToolbarTools = (app: AppClassProperties) => {
  // 按设计精简主工具栏：选择、自由画笔、直线、形状组(矩形作为入口)、文本、橡皮擦
  const CONDENSED = [
    {
      icon: SelectionIcon,
      value: "selection" as const,
      key: KEYS.V,
      numericKey: null,
      fillable: true,
    },
    {
      icon: FreedrawIcon,
      value: "freedraw" as const,
      key: [KEYS.P, KEYS.X],
      numericKey: null,
      fillable: false,
    },
    {
      icon: LineIcon,
      value: "line" as const,
      key: KEYS.L,
      numericKey: null,
      fillable: true,
    },
    {
      icon: RectangleIcon,
      value: "rectangle" as const,
      key: KEYS.R,
      numericKey: null,
      fillable: true,
    },
    {
      icon: TextIcon,
      value: "text" as const,
      key: KEYS.T,
      numericKey: null,
      fillable: false,
    },
    {
      icon: EraserIcon,
      value: "eraser" as const,
      key: KEYS.E,
      numericKey: null,
      fillable: false,
    },
  ] as const;

  return CONDENSED;
};

export const findShapeByKey = (key: string, app: AppClassProperties) => {
  const shape = getToolbarTools(app).find((shape, index) => {
    return (
      (shape.numericKey != null && key === String(shape.numericKey)) ||
      (shape.key &&
        (typeof shape.key === "string"
          ? shape.key === key
          : (shape.key as readonly string[]).includes(key)))
    );
  });
  return shape?.value || null;
};
